
import { Database } from "@/types/supabase";
import { SleepFormData } from "../SleepFormContext";

// Define the sleep session update type using the Supabase generated types
export type SleepSessionUpdate = Database["public"]["Tables"]["sleep_sessions"]["Update"];

// Define type for handle_sleep_session RPC parameters
export type HandleSleepSessionParams = {
  p_caregiver_id: string;
  p_child_id: string;
  p_start_time: string;
  p_end_time: string | null;
  p_location_id: string | null;
  p_environment_id: string | null;
  p_onset_method_id: string | null;
  p_restfulness_id: string | null;
  p_signs_of_sleep_debt: boolean | null;
  p_sound_id: string | null;
  p_sound_level_id: string | null;
  p_notes: string | null;
  p_has_woken_up: string;
  p_status: string;
};

export type StepType = typeof STEPS[number];

export const STEPS = [
  'start',
  'wake_status',
  'end',
  'restfulness',
  'location',
  'environment',
  'onset',
  'sound',
  'sound_level',
  'sleep_debt',
  'notes'
] as const;

export type SleepDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  childId?: string;
  activityToEdit?: any;
  onSuccess?: () => void;
};

export type LookupItem = {
  id: string;
  description: string;
} | {
  id: string;
  name: string;
} | {
  id: string;
  level: string;
} | {
  id: string;
  rating: string;
} | {
  id: string;
  method: string;
};

export type SleepDialogState = {
  saving: boolean;
  currentStep: StepType;
  showConfirmation: boolean;
  isEditing: boolean;
  locations: {id: string, description: string}[];
  environments: {id: string, description: string}[];
  onsetMethods: {id: string, description: string}[];
  sounds: {id: string, name: string}[];
  soundLevels: {id: string, level: string}[];
  restfulnessRatings: {id: string, description: string}[];
};
